module.exports = __webpack_public_path__ + "static/media/B1D58B9D-6CD3-4F7C-BF9B-F28C06D33D71.a786f710.png";